"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeAddressValidation = void 0;
var journey_services_1 = require("@athena-portal/journey-services");
var AnnualHomeAddressValidation = /** @class */ (function (_super) {
    __extends(AnnualHomeAddressValidation, _super);
    function AnnualHomeAddressValidation(props) {
        var _this = _super.call(this) || this;
        _this.props = props;
        if (!_this.props.interactionField) {
            throw Error("AnnualHomeAddressValidation missing interactionField attribute");
        }
        if (!_this.props.unquotablePostCodes) {
            throw Error("AnnualHomeAddressValidation missing unquotablePostCodes attribute");
        }
        if (!_this.props.unquotableAggregatorPostCodes) {
            throw Error("AnnualHomeAddressValidation missing unquotableAggregatorPostCodes attribute");
        }
        return _this;
    }
    AnnualHomeAddressValidation.prototype.validateInput = function (input, context) {
        var pageContext = context;
        if (pageContext.engine) {
            var interaction = pageContext.engine.getInteraction();
            var uiState = journey_services_1.ObjectManipulator.fetchFieldValue("uistate", interaction);
            var isFromAggregator = interaction.source && interaction.source !== "";
            var postCode_1 = journey_services_1.ObjectManipulator.fetchFieldValue(this.props.interactionField, interaction);
            if ((isFromAggregator && this.props.unquotableAggregatorPostCodes.some(function (code) { return postCode_1.startsWith(code); }))
                || (!isFromAggregator && this.props.unquotablePostCodes.some(function (code) { return postCode_1.startsWith(code); }))) {
                uiState.quotablePostCode = false;
                return this.invalidResult(journey_services_1.ExpressionEvaluator.renderTemplate(this.props.unquotablePostCodeErrorMsg, interaction));
            }
            if (input == null) {
                return this.invalidResult("Please select an address to continue");
            }
            uiState.quotablePostCode = true;
        }
        return this.validResult();
    };
    return AnnualHomeAddressValidation;
}(journey_services_1.ValidationMethodBase));
exports.AnnualHomeAddressValidation = AnnualHomeAddressValidation;
//# sourceMappingURL=AnnualHomeAddressValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/validations/AnnualHomeAddressValidation.js
// module id = 2540
// module chunks = 0